import { LegalClientSaveGlobalFinancialMonitoringPartTwoParam } from 'api/types/params';
import { isYes } from 'helpers';

import { CompanyGlobalFinancialMonitoringPartTwoFormType } from '../../forms/companyGlobalFinancialMonitoringPartTwoForm';

export const getSubmitData = (
  values: CompanyGlobalFinancialMonitoringPartTwoFormType
): LegalClientSaveGlobalFinancialMonitoringPartTwoParam => ({
  hasSourceOfFundsProcedures: isYes(values.hasSourceOfFundsProcedures),
  hasRelationshipsWithPEPProcedures: isYes(
    values.hasRelationshipsWithPEPProcedures
  ),
  hasAnonymousAccounts: isYes(values.hasAnonymousAccounts),
  hasAnonymousAccountPreventionProcedures: isYes(
    values.hasAnonymousAccountPreventionProcedures
  ),
  hasTransactionMonitoringProcedures: isYes(
    values.hasTransactionMonitoringProcedures
  ),
  hasAssetFreezingProcedures: isYes(values.hasAssetFreezingProcedures),

  hasAMLTrainingProcedures: isYes(values.hasAMLTrainingProcedures),
  amlTrainingDetails: isYes(values.hasAMLTrainingProcedures)
    ? values.amlTrainingDetails
    : undefined,

  hasBranchesInNonFATFCountries: isYes(values.hasBranchesInNonFATFCountries),
  nonFATFBranchesNamesAndLocations: isYes(values.hasBranchesInNonFATFCountries)
    ? values.nonFATFBranchesNamesAndLocations
    : undefined,

  hasCorrespondentsInNonFATFCountries: isYes(
    values.hasCorrespondentsInNonFATFCountries
  ),
  nonFATFCorrespondentsNames: isYes(values.hasCorrespondentsInNonFATFCountries)
    ? values.nonFATFCorrespondentsNames
    : undefined,

  hasCorrespondentsInOffshoreZones: isYes(
    values.hasCorrespondentsInOffshoreZones
  ),
  offshoreCorrespondentsNames: isYes(values.hasCorrespondentsInOffshoreZones)
    ? values.offshoreCorrespondentsNames
    : undefined,

  hasShellBankRelationships: isYes(values.hasShellBankRelationships),
  shellBanksNames: isYes(values.hasShellBankRelationships)
    ? values.shellBanksNames
    : undefined,

  hasShellBankPreventionProcedures: isYes(
    values.hasShellBankPreventionProcedures
  ),
  hasCDDRequestComplianceProcedures: isYes(
    values.hasCDDRequestComplianceProcedures
  ),

  creditRating: values.creditRating,
  subsidiariesNamesAndLocations: values.subsidiariesNamesAndLocations,
  keyPartnersNames: values.keyPartnersNames,
  foreignBranchesNamesAndLocations: values.foreignBranchesNamesAndLocations,
  financialGroupInfo: values.financialGroupInfo,

  hasSanctionPolicyDocuments: isYes(values.hasSanctionPolicyDocuments),
  hasSanctionsMonitoringProcedures: isYes(
    values.hasSanctionsMonitoringProcedures
  ),
  isUnderSanctionsOrControlledBySanctionedEntity: isYes(
    values.isUnderSanctionsOrControlledBySanctionedEntity
  ),
  isListedInSanctionLists: isYes(values.isListedInSanctionLists),
  isLinkedToSanctionedEntities: isYes(values.isLinkedToSanctionedEntities),
});
